// libs
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { delay } from 'rxjs/operators';
import { ENVIRONMENT, LANGUAGES_SUPPORTED, LOADER_TEXT } from 'src/app/_constants/app.constants'
import { ObjectLiteral } from './_models/user';
// app
import { LanguageService } from 'src/app/_services/api/language/language.service';
import { LoggerService } from 'src/app/_services/ui/logger/logger.service';
import { LoadingService } from 'src/app/_services/ui/loading/loading.service';
import { AnalyticsService } from './_services/sdk/analytics/analytics.service';
import { DOCUMENT } from '@angular/common';
import { SessionService } from './_services/session/session.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ua-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {

  isLoading = true;
  loaderText = '';
  pageConstants: ObjectLiteral;
  subscriptionLanguageServiceStreamer: Subscription;
  ver = '2.7.4'

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private logger: LoggerService,
    private loading: LoadingService,
    private languageService: LanguageService,
    private analyticsService: AnalyticsService,
    private renderer: Renderer2,
    private sessionService: SessionService,
  ) {
    this.languageService.languageChanges.subscribe(() => {
      this.renderer.setAttribute(this.document.body, 'dir', LANGUAGES_SUPPORTED[this.languageService?.currentLanguage]?.direction);
    })
  }


  /**
   *
   * App initializiation
   *
   */
  async ngOnInit() {
    this.sessionService.clearStorageData();
    this.logger.debug('AppComponent.ngOnInit', this, ENVIRONMENT.PROPERTIES)
    if (ENVIRONMENT.PROPERTIES.name != ENVIRONMENT.PREVIEW) {
      this.analyticsService.initTracer();
      this.analyticsService.init();
    }
    this.isLoading = false
    this.listenToLoading();
    this.subscribeLanguageServieStreamer();
  }

  subscribeLanguageServieStreamer() {
    const loadLanguagePreferredFromStorage = this.sessionService.loadLanguagePreferredFromStorage();
    const res = this.languageService.currentLangConfig(loadLanguagePreferredFromStorage)
    if (res) this.sessionService.removeLanguagePreferred();
    this.subscriptionLanguageServiceStreamer = this.languageService.languageServiceStreamer.subscribe((stream: { action: string, data: any }) => {
      if (stream.action === 'sessionService.setLangueage') {
        this.sessionService.setLanguage(stream.data);
      }
    })
  }

  /**
   * Listen to the loadingSub property in the LoadingService class. This drives the
   * display of the loading spinner.
   */
  listenToLoading(): void {
    this.loading.loadingSub
      .pipe(delay(0)) // This prevents a ExpressionChangedAfterItHasBeenCheckedError for subsequent requests
      .subscribe((loading) => {
        let loaderConstants = this.languageService?.constants?.loader || {};
        this.loaderText = loaderConstants[LOADER_TEXT[loading.text.toUpperCase()]] || loaderConstants[LOADER_TEXT.LOADING] || '';
        this.isLoading = loading.loading;
      });
  }

  ngOnDestroy() {
    this.subscriptionLanguageServiceStreamer.unsubscribe();
  }

}


